module.exports = __webpack_public_path__ + "static/media/datenschutzerklaerung.a5282707.pdf";